import { ImportModulesState } from '@pages/user-management/store/store/states/import-modules.state';
import { AccessGroupsState } from '@pages/user-management/store/store/states/access-groups.state';
import { ImportModuleUsersState } from '@pages/user-management/store/store/states/import-module-users.state';
import { IPAddressState } from '@pages/user-management/store/store/states/ip-address.state';
import { BulkUserImportState } from '@pages/user-management/store/store/states/bulk-user-import.state';
import { UserManagementState } from '@pages/user-management/store/store/states/user-management.state';

export const userManagementState = [
  ImportModulesState,
  AccessGroupsState,
  ImportModuleUsersState,
  IPAddressState,
  BulkUserImportState,
  UserManagementState,
];
